<template>
    <div id="deco-homes-wrapper">
        <div id="deco-portfolio">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="bg-black text-white">
                <b-container class="py-100">
                    <p class="gotham-bold">
                        WEBSITE
                    </p>
                    <p class="gotham-book mb-0">
                        Our primary goal was to highlight three unique lifestyles that align with Southport’s surrounding neighbourhoods of Bloor West Village, High Park, and Lake Ontario. We kept the website clean and simple; developing a clear user interface, easy-to-use navigation, and strong, yet concise messaging to showcase all that Southport has to offer. Everything here supports the community’s main messaging pillar – “there are three sides to the Southport story”.
                    </p>
                </b-container>
            </section>
            <section>
                <FullWidthSliderWithColumns 
                :slides="sliderWithColumns"
                :styles="sliderWithColumnsStyles"/>
            </section>
            <section class="">
                <video 
                src="/videos/Southport.mp4" 
                loop
                autoplay
                muted
                class="w-100 d-block">
                </video>
            </section>
            <section>
                <FullWidthSlider 
                :slides="firstSliderItems"
                :styles="firstSliderStyles"/>
            </section>
            <section>
                <video 
                src="/videos/Southport-final.mp4" 
                loop
                autoplay
                muted
                class="w-100 d-block">
                </video>
            </section>
            <ImageAndTextPortfolio 
                :imageAndTextContent="imageAndTextContent"
            />
            <section>
                <img src="/img/portfolio/southport/southport-entrance-rendering.jpg" alt="Southport Entrance Rendering" class="d-block w-100">
            </section>
            <section>
                <ImageAndTextPortfolio 
                :imageAndTextContent="secondImageAndTextContent"
            />
            </section>
            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
        <!-- <div>
            <FullWidthSlider2 
            :slides="secondSliderItems"
            :styles="secondSliderStyles"/>
        </div> -->
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - 1063 Eglinton Ave",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_decoHomes: null,
            textAnimation_decoHomes: null,
            fadeInUpElement_decoHomes: null,
            disciplines: [
                {
                    name: "real estate development"
                }
            ],
            services: [
                {
                    name: "web design"
                },
                {
                    name: "web development"
                },
                {
                    name: "social media"
                },
                {
                    name: "account management"
                },
                {
                    name: "brochure design"
                },
                {
                    name: "magazine writing"
                },
                {
                    name: "magazine design"
                },
                {
                    name: "truck design"
                }
            ],
            pageName: "Southport Condos",
            pageLink: "",
            linkName: "",
            sliderWithColumns: [
                {
                    img: "/img/portfolio/southport/southport-logo-on-stipple-bg.jpg",
                    alt: "Southport",
                    imgLeft: "/img/portfolio/southport/southport-logo-red-bg.jpg",
                    imgRight: "/img/portfolio/southport/southport-logo-text-blue-bg.jpg",
                }
            ],
            sliderWithColumnsStyles: {
                bgColor: '#00b0bf',
                textColor: '#fff',
                sliderClass: '',
                imgOnLeftSide: true,
                heading: "LOGO",
                desc: "We designed the logo to symbolize each of Southport’s three surrounding neighbourhoods, or three distinct sides. Yellow represents Bloor West Village, red is High Park and blue naturally defines Lake Ontario. Together, they create a complete logo that visually explains Southport’s unique benefits.",
                subheading: ''
            },
            fullWidthSliderImages: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-1.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-2.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-3.jpg",
                    alt: "DECO Magazie"
                }
            ],
            firstSliderStyles: {
                bgColor: '#df5e61',
                textColor: '#fff',
                sliderClass: false,
                imgOnLeftSide: true,
                heading: "PRESENTATION CENTRE",
                desc: "1063 brought Southport’s upscale elegance to life through beautiful furnishings that convey the luxurious nature of this prime downtown offering. Modernism and refinement flow through this space to represent the quality of Southport’s suites, amenities, and location. A beautiful variety of amenity maps, scale models, finish boards, and interactive displays created an immersive and memorable experience. In all, we created an innovative environment that immersed potential buyers in the Southport lifestyle and invited them to discover their own story at Southport.",
                subheading: ''
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/southport/slider/sp-slider-half-front-desk.jpg",
                    alt: "Southport Sales Office"
                },
                {
                    img: "/img/portfolio/southport/slider/sp-slider-half-office-decor.jpg",
                    alt: "Southport Sales Office"
                },
                {
                    img: "/img/portfolio/southport/slider/sp-slider-half-reception.jpg",
                    alt: "Southport Sales Office"
                },
                {
                    img: "/img/portfolio/southport/slider/sp-slider-half-seating-area.jpg",
                    alt: "Southport Sales Office"
                },
                {
                    img: "/img/portfolio/southport/slider/sp-slider-half-word-wall.jpg",
                    alt: "Southport Sales Office"
                }
            ],
            secondSliderStyles: {
                bgColor: '#00b0bf',
                textBackgroundImg: '',
                imgOnLeftSide: false,
                imgPadding: false,
                textColor: 'text-white',
                sliderClass: false,
                heading: "BROCHURE",
                desc: "In essence, the Southport brochure is a collection of our greatest marketing deliverables. Renderings, amenity maps, neighbourhood guides, and persuasive copy combined to create a comprehensive sales piece that had a lasting impact on potential homebuyers.",
                subheading: ''
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/southport/southport-booklets.jpg",
                    heading: "Brochure"
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: false,
                imgPadding: true,
                bgColor: '',
                bgImageClass: "stipple-bg",
                textColor: "#000",
                img: "/img/portfolio/southport/southport-icecream-truck.jpg",
                alt: "Southport Ice Cream Event",
                heading: "RENDERINGS",
                desc: "Precise renderings were carefully created to offer a realistic snapshot of everything available at Southport. Featured on a range of marketing deliverables, these beautiful images showcase impressive views, elegant suites, an array of modern amenities, and an unparalleled lifestyle experience."
            },
            secondImageAndTextContent: {
                imgOnLeftSide: false,
                imgPadding: false,
                bgColor: '#00b0bf',
                bgImageClass: "",
                textColor: "#fff",
                img: false,
                video: "/videos/Southport2.mp4",
                alt: "Southport Brochure",
                heading: "BROCHURE",
                desc: "In essence, the Southport brochure is a collection of our greatest marketing deliverables. Renderings, amenity maps, neighbourhood guides, and persuasive copy combined to create a comprehensive sales piece that had a lasting impact on potential homebuyers."
            },
            nextProject: {
                link: "/portfolio/vupoint",
                name: "VuPoint 2"
            }
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSliderWithColumns: () => import('@/components/FullWidthSliderWithColumns'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        FullWidthImageSlider: () => import('@/components/FullWidthImageSlider'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_decoHomes();
            // 
            this.initImgElReveal_decoHomes();
            this.initTextReveal_decoHomes();
        }, 500)
    },
    methods: {
        initscrollSmoother_decoHomes() {
            this.scrollSmoother_decoHomes = ScrollSmoother.create({
                wrapper: '#deco-homes-wrapper',
                content: "#deco-portfolio",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_decoHomes.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_decoHomes() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_decoHomes = this.fadeInUpElement_decoHomes;
                fadeInUpElement_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_decoHomes.set(container, { autoAlpha: 1 });
                fadeInUpElement_decoHomes.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_decoHomes() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_decoHomes = this.textAnimation_decoHomes;
                textAnimation_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_decoHomes.set(container, { autoAlpha: 1 });
                textAnimation_decoHomes.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_decoHomes.kill();
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables';

</style>